import { Button } from "./ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";

interface SpecSheetDownloadProps {
  robotModel: string;
  pdfUrl?: string;
}

export const SpecSheetDownload = ({ robotModel, pdfUrl }: SpecSheetDownloadProps) => {
  const handleDownload = () => {
    if (pdfUrl) {
      // If PDF URL is provided, download it
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${robotModel}-Specifications.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Spec sheet downloading...");
    } else {
      // If no PDF URL, show coming soon message
      toast.info("Spec sheet will be available soon. Please contact us for detailed specifications.", {
        action: {
          label: "Contact Us",
          onClick: () => window.location.href = "tel:+13369624539"
        }
      });
    }
  };

  return (
    <Button size="lg" variant="secondary" onClick={handleDownload}>
      <Download className="mr-2 h-5 w-5" />
      Download Spec Sheet
    </Button>
  );
};
